<template>

    <div>
        <settingsNav></settingsNav>
        <v-container>

            <v-layout row wrap>
                <v-flex xs12 sm12 pb-5 mb-2>
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card>
                                <v-card-title>
                                    <v-layout row wrap>
                                        <v-flex xs12 md8>
                                            <v-card-title class="headline">
                                                Cash Flow
                                            </v-card-title>
                                        </v-flex>
                                    </v-layout>
                                </v-card-title>

                                <!--                            Status Or Filter Header-->
                                <v-layout row wrap>

                                    <v-flex xs12 md2 pl-4 pr-2>
                                        <v-autocomplete
                                                clearable
                                                :items="getCustomers"
                                                label="Customer"
                                                v-model="selectedCustomersID"
                                                item-value="id"
                                                item-text="name"
                                                :search-input.sync="searchCustomer"
                                                height="48"
                                        ></v-autocomplete>
                                    </v-flex>


                                    <v-flex xs12 md2 pl-4 pr-2>
                                        <v-autocomplete
                                                clearable
                                                :items="getAllSuppliers"
                                                label="Supplier"
                                                v-model="selectedSupplierID"
                                                item-value="id"
                                                item-text="name"
                                                height="48"
                                        ></v-autocomplete>
                                    </v-flex>

                                    <v-flex grow>

                                    </v-flex>

                                    <v-flex xs12 md2 pl-4 pr-2>
                                        <v-menu
                                                ref="menu"
                                                v-model="selectFromMenu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        :value="selectFromDate | toDateOnly"
                                                        label="Select From"
                                                        prepend-icon="fas fa-calendar"
                                                        readonly
                                                        v-on="on"
                                                        height="48"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="selectFromDate" @input="selectFromMenu = false" no-title
                                                           scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn flat color="primary"
                                                       @click="resetDate(selectFromDate, selectFromMenu)">CLEAR
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>

                                    <v-flex xs12 md2 pl-4 pr-2>
                                        <v-menu
                                                ref="menu"
                                                v-model="selectToMenu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        :value="selectToDate | toDateOnly"
                                                        label="Select To"
                                                        prepend-icon="fas fa-calendar"
                                                        readonly
                                                        v-on="on"
                                                        height="48"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="selectToDate" @input="selectToMenu = false" no-title
                                                           scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn flat color="primary" @click="resetDate(selectToDate, selectToMenu)">
                                                    CLEAR
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 pl-3>
                                        <v-card-title class="headline">
                                            Purchase orders
                                        </v-card-title>
                                    </v-flex>

                                    <v-flex xs12 md8 pl-4 pr-2>
                                        <column-chart :library="options" :discrete="true" height="100%" legend="bottom" thousands="." prefix="€"
                                                      :data="getPurchaseOrderIncome"></column-chart>
                                    </v-flex>

                                    <v-flex xs12 md4 pl-4 pr-2>
                                        <v-data-table
                                                :headers="purchaseOrderTableHeader"
                                                :items="getPurchaseOrderTableData"
                                                class="elevation-0"
                                                :loading="loading"
                                                hide-actions
                                        >

                                            <template slot="headerCell" slot-scope="props">
                                                <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                                    <span>
                                          {{ props.header.text }}
                                        </span>
                                                </v-tooltip>
                                            </template>
                                            <template slot="items" slot-scope="props">
                                                <tr>
                                                    <td>{{ props.item.month | toShortMonthYear }}</td>
                                                    <td>{{ formatToMoney(props.item.sales) }}</td>
                                                    <td>{{ formatToMoney(props.item.purchase) }}</td>
                                                    <td>{{ formatToMoney(props.item.profit) }}</td>
                                                    <td class="text-xs-right">{{ formatToMoney(props.item.profit_in_percent) }}</td>
                                                </tr>
                                            </template>
                                            <template  v-slot:footer>
                                                <td :colspan="1">
                                                    <strong>Total</strong>
                                                </td>
                                                <td :colspan="1">
                                                    <strong>
                                                        {{ formatToMoney(calculatePurchaseOrderTableDateTotal.sales) }}
                                                    </strong>
                                                </td>
                                                <td :colspan="1">
                                                    <strong>
                                                        {{ formatToMoney(calculatePurchaseOrderTableDateTotal.purchase) }}
                                                    </strong>
                                                </td>
                                                <td :colspan="1" style="padding-right: 0">
                                                    <strong>
                                                           {{ formatToMoney(calculatePurchaseOrderTableDateTotal.profit) }}
                                                    </strong>
                                                </td>
                                                <td class="text-xs-right" :colspan="1" style="padding-right: 24px">
                                                    <strong>
                                                        {{formatToMoney(calculatePurchaseOrderTableDateTotal.profit_in_percent)}}
                                                    </strong>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 pl-3>
                                        <v-card-title class="headline">
                                            Invoices by due date
                                        </v-card-title>
                                    </v-flex>

                                    <v-flex xs12 md8 pl-4 pr-2>
                                        <column-chart :library="options" :discrete="true" height="100%" legend="bottom" thousands="." prefix="€"
                                                      :data="getInvoiceIncome"></column-chart>
                                    </v-flex>
                                    <v-flex xs12 md4 pl-4 pr-2>
                                        <v-data-table
                                                :headers="invoiceIncomeTableHeader"
                                                :items="getInvoiceIncomeTableData"
                                                class="elevation-0"
                                                :loading="loading"
                                                hide-actions
                                        >

                                            <template slot="headerCell" slot-scope="props">
                                                <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                                    <span>
                                          {{ props.header.text }}
                                        </span>
                                                </v-tooltip>
                                            </template>
                                            <template slot="items" slot-scope="props">
                                                <tr>
                                                    <td>{{ props.item.month | toShortMonthYear }}</td>
                                                    <td class="text-xs-right">{{ formatToMoney(props.item.income) }}</td>
                                                </tr>
                                            </template>
                                            <template  v-slot:footer>
                                                <td :colspan="1">
                                                    <strong>Total</strong>
                                                </td>
                                                <td class="text-xs-right" :colspan="1" style="padding-right: 24px">
                                                    <strong>
                                                        {{formatToMoney(calculateInvoiceIncomeTableDateTotal.income)}}
                                                    </strong>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>


                                <v-layout row wrap>
                                    <v-flex xs12 pl-3>
                                        <v-card-title class="headline">
                                            Purchase by due date
                                        </v-card-title>
                                    </v-flex>
                                    <v-flex xs12 md8 pl-4 pr-2>
                                        <column-chart :library="options" :discrete="true" height="100%" legend="bottom" thousands="." prefix="€"
                                                      :data="getSupplierToPay"></column-chart>
                                    </v-flex>

                                    <v-flex xs12 md4 pl-4 pr-2>
                                        <v-data-table
                                                :headers="supplierPurchaseTableHeader"
                                                :items="getSupplierToPayTableData"
                                                class="elevation-0"
                                                :loading="loading"
                                                hide-actions
                                        >

                                            <template slot="headerCell" slot-scope="props">
                                                <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                                    <span>
                                          {{ props.header.text }}
                                        </span>
                                                </v-tooltip>
                                            </template>
                                            <template slot="items" slot-scope="props">
                                                <tr>
                                                    <td>{{ props.item.month | toShortMonthYear }}</td>
                                                    <td class="text-xs-right">{{ formatToMoney(props.item.purchase_value) }}</td>
                                                </tr>
                                            </template>
                                            <template  v-slot:footer>
                                                <td :colspan="1">
                                                    <strong>Total</strong>
                                                </td>
                                                <td class="text-xs-right" :colspan="1" style="padding-right: 24px">
                                                    <strong>
                                                        {{formatToMoney(calculateSupplierToPayTableDateTotal.purchase_value)}}
                                                    </strong>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>


                                <v-flex xs12 pl-3>
                                    <v-card-title class="headline">
                                        <v-layout row wrap>
                                            <v-flex xs12 md8>
                                                <v-card-title class="headline">
                                                    Unpaid Supplier Orders
                                                </v-card-title>
                                            </v-flex>
                                            <v-flex xs12 md4>
                                                <v-text-field
                                                        v-model="search"
                                                        append-icon="search"
                                                        label="Search"
                                                        single-line
                                                        hide-details
                                                        clearable
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-title>

                                </v-flex>

                                <v-container>
                                    <v-data-table
                                            :headers="headers"
                                            :items="getItems"
                                            class="elevation-0"
                                            :loading="loading"
                                            hide-actions
                                    >

                                        <template slot="headerCell" slot-scope="props">
                                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                                <span>
                                          {{ props.header.text }}
                                        </span>
                                            </v-tooltip>
                                        </template>
                                        <template slot="items" slot-scope="props">
                                            <!--           <v-touch tag="tr"
                                                                @doubletap="openDialog(props.item.id)"
                                                                @dblclick="openDialog(props.item.id)">-->

                                            <tr>

                                                <td>{{ props.item.supplier_name }}</td>

                                                <td>
                                                    <v-btn  :loading="loadingSupplierOrder === props.item.id" :disabled="props.item.purchase_orders_number === null"
                                                            small
                                                            flat
                                                            @click.native="openSupplierOrderDialog(props.item.id)"
                                                    >
                                                        {{ props.item.purchase_orders_number }}
                                                    </v-btn>
                                                </td>

                                                <td>{{ props.item.customer_name }}</td>

                                                <td>{{ props.item.confirmation_received | toDateOnly }}</td>

                                                <td v-if="props.item.days > 0 && !isProforma(props.item.is_proforma)"><v-chip color="green" text-color="white" small>{{props.item.days}} days</v-chip></td>
                                                <td v-if="isProforma(props.item.is_proforma) && props.item.days > 0"><v-chip color="orange" text-color="white" small><s>{{props.item.days}} days</s></v-chip></td>
                                                <td v-if="props.item.days === 0">-</td>

                                                <td>{{ props.item.due_date | toDateOnly}}</td>

                                                <td v-if="isProforma(props.item.is_proforma)"><v-chip color="red" text-color="white" small>Proforma</v-chip></td>
                                                <td v-else>-</td>

                                                <td>{{ formatToMoney(props.item.purchase_price)}}</td>

                                                <!--       </v-touch>-->

                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-container>

                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>

            <addSupplierOrderDialog v-if="supplierOrderDialogState"></addSupplierOrderDialog>

        </v-container>
    </div>

</template>

<script>
    import {
        Settings,
        CashFlow,
        Customer,
        SupplierOrder
    } from '../../store/namespace-helper'

    import _ from 'lodash'
    import moment from 'moment'
    import settingsNav from '../Shared/SettingsNav.vue'
    import addSupplierOrderDialog from '../SupplierOrders/AddSupplierOrderDialog.vue'

    import {$$} from 'moneysafe/ledger'
    import {$} from 'moneysafe'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {propertyHelperMixin} from '../../mixins/propertyHelperMixin'

    export default {
      name: 'CashFlow',
      components: {
        settingsNav,
        addSupplierOrderDialog
      },
      mixins: [dateFunctionFilters, propertyHelperMixin],
      props: {},
      data () {
        return {
          isVisible: false,
          pagination: {'sortBy': 'delivery_date', 'ascending': true},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [25, 10, 50, 100, 250],
          deleteDialog: false,
          deleteChecked: false,
          deleteFormValidation: false,
          supplierOrderToDelete: null,
          selectedSupplierID: null,
          selectedSupplierOrderPositionStatusIDs: [],
          selectedCustomersID: null,
          selectFromDate: null,
          selectToDate: null,
          selectToMenu: false,
          selectFromMenu: false,
          chipsDeletable: true,
          loadingSupplierOrder: 0,
          loadingPurchaseOrder: 0,
          loadingProcurement: 0,
          renderSupplierOrderDialog: false,
          renderOrderDialog: false,
          renderProcurementDialog: false,
          supplierOrderPositionStatuses: [],
          searchCustomer: null,
          options: {
            animation: {
              duration: 1250,
                    /* easing: "linear", */
              onProgress: function (animation) {
                        // progress.value = animation.animationObject.currentStep / animation.animationObject.numSteps;
                        // console.log("progress!!!")
              }
            }
          }
        }
      },
      mounted () {
        this.loadItems()
        this.loadAllSuppliers()
        this.loadCustomers()
        // applying styles to selector filters
        let selectors = document.getElementsByClassName('v-select__selections')
        for (let i = 0; i < selectors.length; i++) {
          selectors[i].style.maxHeight = '42px'
          selectors[i].style.overflowX = 'scroll'
        }
      },
      methods: {
        loadItems () {
       /*   const {sortBy, descending, page, rowsPerPage} = this.pagination */

          const query = {
/*            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
             */
            search: this.search ? this.search : '',
            customers_id: this.selectedCustomersID ? this.selectedCustomersID : 0,
            suppliers_id: this.selectedSupplierID ? this.selectedSupplierID : 0,
            selectedFrom: this.selectFromDate ? this.selectFromDate : null,
            selectedTo: this.selectToDate ? this.selectToDate : null
          }
          this.$store.dispatch(CashFlow.actions.loadCashFlows, query)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        },
        loadAllSuppliers: function () {
          this.$store.dispatch(Settings.actions.loadAllSuppliers)
        },
        loadCustomers () {
          const query = {
            search: this.searchCustomer ? this.searchCustomer : ''
          }
          this.$store.dispatch(Customer.actions.loadCustomers, query)
        },
        resetDate (model, menu) {
          if (this.selectFromDate === model) {
            this.selectFromDate = null
            this.selectFromMenu = false
          } else if (this.selectToDate === model) {
            this.selectToDate = null
            this.selectToMenu = false
          }
        },
        formatToMoney (number) {
          return new Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2

          }).format(number)
        },
        isProforma (value) {
          if (value === 'true') {
            return true
          } else {
            return false
          }
        },
        openSupplierOrderDialog (val) {
          if (val !== null) {
            this.loadingSupplierOrder = val
            this.$store.dispatch(SupplierOrder.actions.loadSupplierOrderById, val).then(response => {
              this.$store.dispatch(SupplierOrder.actions.setSelectedSupplierOrder, response.data.data)
                      /*       this.renderSupplierOrderDialog = true */
              this.$store.dispatch(SupplierOrder.actions.openCloseDialog)
              this.loadingSupplierOrder = 0
            }).catch(err => {
              console.log(JSON.stringify(err))
              this.loadingSupplierOrder = 0
            })
          }
        }
      },
      computed: {
        getItems () {
          this.total = this.$store.getters[CashFlow.getters.cashFlow].suppliers_to_pay.length
          return this.$store.getters[CashFlow.getters.cashFlow].suppliers_to_pay
        },
        getPurchaseOrderTableData () {
          return this.$store.getters[CashFlow.getters.cashFlow].monthly_purchase_order_income
        },
        calculatePurchaseOrderTableDateTotal () {
          let total = {
            sales: 0,
            purchase: 0,
            profit: 0,
            profit_in_percent: 0
          }
          this.$store.getters[CashFlow.getters.cashFlow].monthly_purchase_order_income.forEach(function (item) {
            total.sales = $$(
                $(total.sales),
                $(item.sales)
            ).$
            total.purchase = $$(
                $(total.purchase),
                $(item.purchase)
            ).$
            total.profit = $$(
                $(total.profit),
                $(item.profit)
            ).$
          })
          total.profit_in_percent = (total.profit / total.sales) * 100

          return total
        },
        getPurchaseOrderIncome () {
          let barData = [
            {
              name: 'Sales',
              data: []
            },
            {
              name: 'Purchase',
              data: []
            },
            {
              name: 'Profit',
              data: []
            }
          ]

          this.$store.getters[CashFlow.getters.cashFlow].monthly_purchase_order_income.forEach(function (item) {
            let displayMonthYear = moment(String(item.month)).format('MMM YYYY')
            barData[0].data.push([displayMonthYear, item.sales])
            barData[1].data.push([displayMonthYear, item.purchase])
            barData[2].data.push([displayMonthYear, item.profit])
          })

          return barData
        },
        getInvoiceIncomeTableData () {
          return this.$store.getters[CashFlow.getters.cashFlow].monthly_invoice_income
        },
        calculateInvoiceIncomeTableDateTotal () {
          let total = {
            income: 0
          }
          this.$store.getters[CashFlow.getters.cashFlow].monthly_invoice_income.forEach(function (item) {
            total.income = $$(
                      $(total.income),
                      $(item.income)
                  ).$
          })

          return total
        },
        getInvoiceIncome () {
          let barData = [
            {
              name: 'Income',
              data: []
            }
          ]

          this.$store.getters[CashFlow.getters.cashFlow].monthly_invoice_income.forEach(function (item) {
            let displayMonthYear = moment(String(item.month)).format('MMM YYYY')
            barData[0].data.push([displayMonthYear, item.income])
          })

          return barData
        },
        getSupplierToPayTableData () {
          return this.$store.getters[CashFlow.getters.cashFlow].monthly_supplier_to_pay
        },
        calculateSupplierToPayTableDateTotal () {
          let total = {
            purchase_value: 0
          }
          this.$store.getters[CashFlow.getters.cashFlow].monthly_supplier_to_pay.forEach(function (item) {
            total.purchase_value = $$(
                      $(total.purchase_value),
                      $(item.purchase_value)
                  ).$
          })

          return total
        },
        getSupplierToPay () {
          let barData = [
            {
              name: 'Purchase value',
              data: []
            }
          ]

          this.$store.getters[CashFlow.getters.cashFlow].monthly_supplier_to_pay.forEach(function (item) {
            let displayMonthYear = moment(String(item.month)).format('MMM YYYY')
            barData[0].data.push([displayMonthYear, item.purchase_value])
          })

          return barData
        },

        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getActiveTab () {
          if (this.procurementId === null) {
            return 0
          } else {
            return 2
          }
        },
        supplierOrderDialogState () {
          return this.$store.getters[SupplierOrder.getters.getOpenDialogState]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        getAllSuppliers () {
          return this.$store.getters[Settings.getters.getAllSuppliers]
        },
        getCustomers () {
          return this.$store.getters[Customer.getters.customers]
        },
        purchaseOrderTableHeader () {
          return [
            {
              text: 'Month',
              value: 'month',
              sortable: false
            },
            {
              text: 'Sales',
              value: 'sales',
              sortable: false
            },
                {text: 'Purchase', value: 'purchase', sortable: false},
            {
              text: 'Profit',
              value: 'profit',
              sortable: false
            },
            {
              text: 'Profit in Percent',
              value: 'profit_in_percent',
              sortable: false
            }
          ]
        },
        invoiceIncomeTableHeader () {
          return [
            {
              text: 'Month',
              value: 'month',
              sortable: false
            },
            {
              text: 'Income',
              value: 'income',
              align: 'right',
              sortable: false
            }
          ]
        },
        supplierPurchaseTableHeader () {
          return [
            {
              text: 'Month',
              value: 'month',
              sortable: false
            },
            {
              text: 'Purchase Value',
              value: 'purchase_value',
              align: 'right',
              sortable: false
            }
          ]
        },
        headers () {
          return [
            {
              text: 'Supplier',
              value: 'supplier_name',
              sortable: false
            },
            {
              text: 'Supplier PO',
              value: 'purchase_orders_number',
              sortable: false
            },
            {text: 'Customer(Client)', value: 'customer_name', sortable: false},
            {
              text: 'Confirmation Received',
              value: 'confirmation_received',
              sortable: false
            },
            {
              text: 'Term of payment',
              value: 'days',
              sortable: false
            },
            {
              text: 'Due date',
              value: 'due_date',
              sortable: false
            },
            {
              text: 'Proforma',
              value: 'is_proforma',
              sortable: false
            },
            {
              text: 'Purchase price',
              value: 'purchase_price',
              sortable: false
            }
          ]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectedSupplierID: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectedCustomersID: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectFromDate: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectToDate: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        searchCustomer: {
          handler (val) {
            this.loadCustomers()
          },
          deep: true
        },
        supplierOrderDialogState: {
          handler (val) {
            if (!val) {
              this.throttledLoadItems()
            }
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

    .deadlineFieldGreen {
        white-space: nowrap;
        text-align: left;
        height: 44px;
        color: rgba(19, 113, 19, 0.75);
        font-weight: bold;
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .deadlineFieldYellow {
        white-space: nowrap;
        text-align: left;
        height: 44px;
        color: rgba(255, 194, 16, 0.83);
        font-weight: bold;
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .deadlineFieldRed {
        white-space: nowrap;
        /*        background-color: rgba(255, 0, 0, 0.75);*/
        text-align: left;
        height: 44px;
        /* color: white;*/
        color: rgba(255, 0, 0, 0.75);
        font-weight: bold;
        /*        border-radius: 16px;*/
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .deadlineFieldNormal {
        white-space: nowrap;
        text-align: left;
        height: 44px;
        color: rgba(0, 0, 0, 0.75);
        font-weight: bold;
        padding-bottom: 15px;
        padding-top: 15px;
    }


</style>




// WEBPACK FOOTER //
// src/components/CashFlow/CashFlow.vue